const features_list = [
  {
    title: '暗夜追踪：城市猎影',
    tag: '本周最热',
    desc: '一场跨越三个城市的深夜追凶，每个夜晚都有新的线索浮出水面。高智商罪犯与王牌警探的心理博弈，让你看完一集就停不下来。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20night%20cityscape%20with%20detective%20silhouette%20walking%20through%20rain-soaked%20street%2C%20neon%20reflections%20on%20wet%20pavement%2C%20warm%20amber%20streetlights%20casting%20long%20shadows%2C%20film%20noir%20atmosphere%20with%20mysterious%20mood&width=1200&height=600&seq=carousel-feature-01&orientation=landscape',
    tagColor: 'bg-primary-500',
    icon: 'ri-movie-2-line',
  },
  {
    title: '星海迷途：深空回响',
    tag: '热播中',
    desc: '人类星际舰队在深空接收到一段来自百年前的求救信号，而这艘飞船的舰长竟然是现任舰队指挥官失踪多年的父亲。',
    img: 'https://readdy.ai/api/search-image?query=Massive%20futuristic%20spaceship%20floating%20in%20deep%20space%20with%20glowing%20nebula%20background%2C%20warm%20golden%20interior%20lights%20shining%20through%2C%20cinematic%20sci-fi%20wide%20shot%20with%20epic%20scale%2C%20atmospheric%20and%20majestic&width=1200&height=600&seq=carousel-feature-02&orientation=landscape',
    tagColor: 'bg-accent-500',
    icon: 'ri-rocket-2-line',
  },
  {
    title: '午夜食堂：第四季回归',
    tag: '新季上线',
    desc: '城市深夜不打烊的小餐馆迎来第四季，新厨师、新食客、新故事。一碗热汤面温暖整座城市的夜归人，深夜美食治愈继续。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20intimate%20restaurant%20kitchen%20at%20night%20with%20steam%20rising%20from%20cooking%20pots%2C%20soft%20amber%20lantern%20lighting%2C%20wooden%20counter%20with%20bowls%2C%20cozy%20Japanese%20izakaya%20atmosphere%2C%20cinematic%20depth%20of%20field&width=1200&height=600&seq=carousel-feature-03&orientation=landscape',
    tagColor: 'bg-secondary-500',
    icon: 'ri-restaurant-line',
  },
  {
    title: '极限追凶：极速72小时',
    tag: '动作大片',
    desc: '退役赛车手意外卷入地下赛车集团惊天阴谋，72小时内必须在午夜高架上完成一场生死竞速，否则一切都将无法挽回。',
    img: 'https://readdy.ai/api/search-image?query=High-speed%20night%20racing%20scene%20on%20elevated%20highway%20with%20city%20skyline%20background%2C%20dramatic%20motion%20blur%2C%20warm%20golden%20streetlights%20reflecting%20on%20asphalt%2C%20cinematic%20action%20photography%20with%20intense%20atmosphere&width=1200&height=600&seq=carousel-feature-04&orientation=landscape',
    tagColor: 'bg-primary-500',
    icon: 'ri-speed-up-line',
  },
  {
    title: '月光恋人：午夜邂逅',
    tag: '浪漫新片',
    desc: '两个习惯熬夜的人在午夜电影院相遇，一场银幕光影间的浪漫邂逅。从陌生到熟悉，他们发现对方正是自己深夜不眠的理由。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20empty%20cinema%20at%20night%20with%20warm%20projector%20beam%20illuminating%20dust%20particles%2C%20vintage%20red%20velvet%20seats%2C%20soft%20golden%20glow%2C%20intimate%20atmosphere%2C%20cinematic%20composition%20with%20dreamy%20bokeh&width=1200&height=600&seq=carousel-feature-05&orientation=landscape',
    tagColor: 'bg-accent-500',
    icon: 'ri-heart-line',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            午夜精选
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            编辑精选的当季必看焦点影视大片
          </p>
        </div>

        <div className="flex flex-col gap-5">
          {features_list.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col lg:flex-row bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="lg:w-[420px] flex-shrink-0 relative overflow-hidden bg-background-200">
                <div className="aspect-[16/9] lg:aspect-auto lg:h-full w-full">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="absolute top-4 left-4">
                  <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-background-50 text-xs font-semibold ${item.tagColor}`}>
                    <i className={`${item.icon} text-xs`}></i>
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex-1 p-5 md:p-7 flex flex-col justify-center">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {item.desc}
                </p>
                <div className="flex items-center gap-4">
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 cursor-pointer group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    <i className="ri-play-circle-fill text-lg"></i>
                    立即观看
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    高清 1080P · 中文字幕
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}